@switch (columnName) {
  @case ('jobType') {
    {{ element?.jobType?.name }}
  }
  @case ('departments') {
    @for (department of element.departments; track department?.id ?? department) {
      <div>
        {{ department }}
      </div>
    }
    @if (element.requiredForPositionGroups !== null) {
      <div>
        <br />
        @for (depGroup of element.departmentGroups; track depGroup?.id ?? depGroup) {
          <div>
            {{ depGroup }}
          </div>
        }
      </div>
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
